import {
    GET_CURRENT_CITY,
    CURRENT_CITY_RECEIVED,
    GET_CITY_CONFIGURATION,
    CITY_CONFIGURATION_RECEIVED,
    GET_CURRENT_CITY_HAS_REAL_TIME_DATA,
    CURRENT_CITY_HAS_REAL_TIME_DATA_RECEIVED,
    SET_IS_USER_LOGGED_IN,
    CurrentCityReceived,
    CurrentCityHasRealTimeDataReceived,
    CityConfigurationReceived,
    SetIsUserLoggedIn
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const getCurrentCity = createAction(GET_CURRENT_CITY);

export const currentCityReceived =
    createAction<CurrentCityReceived["payload"]>(CURRENT_CITY_RECEIVED);

export const getCurrentCityHasRealTimeData = createAction(GET_CURRENT_CITY_HAS_REAL_TIME_DATA);

export const currentCityHasRealTimeDataReceived = createAction<
    CurrentCityHasRealTimeDataReceived["payload"]
>(CURRENT_CITY_HAS_REAL_TIME_DATA_RECEIVED);

export const getCityConfiguration = createAction(GET_CITY_CONFIGURATION);

export const cityConfigurationReceived = createAction<CityConfigurationReceived["payload"]>(
    CITY_CONFIGURATION_RECEIVED
);

export const setIsUserLoggedIn = createAction<SetIsUserLoggedIn["payload"]>(SET_IS_USER_LOGGED_IN);
